import { Component } from '@angular/core';

@Component({
  selector: 'app-user-wallet',
  templateUrl: './user-wallet.component.html',
  styleUrl: './user-wallet.component.css'
})
export class UserWalletComponent {

}
